export default{
    personalAuth:{
        btnState:{
            btn1:'Cancel',
            btn2:'Save & Submit for Review'
        },
        titleList:{
            title1:'Identity',
            title2:'Verification',
            title3:'Male',
            title4:'Female',
            title5:'Permanent',
            title6:'ID Card Front',
            title7:'ID Card Back',
            title8:'ID Holding Photo (Selfie)'
        },
        fromtitle:{
            from1:'Full Name:',
            from2:'Gender:',
            from3:'ID Number:',
            from4:'ID Expiry Date:',
            from5:'Contact Number:',
        },
        placeholderlist:{
            pla1:'Enter your legal name',
            pla2:'Enter ID card number',
            pla3:'Select date',
            pla4:'Enter mobile number',
        },
        rulesMessage:{
            rule1:'Upload front side of ID card',
            rule2:'Upload back side of ID card',
            rule3:'Upload ID holding photo',
            rule4:'Enter your legal name',
            rule5:'Legal name must be 2-20 characters',
            rule6:'Enter valid ID card number',
            rule7:'Select valid expiry date',
            rule8:'Enter mobile number',
            rule9:'Invalid mobile number',
            rule10:'Upload valid image format',
            rule11:'Image size cannot exceed 10MB',
            rule12:'Upload ID documents (JPG/JPEG/PNG, max 10MB)',
            rule13:'Saved successfully'
        }
    }
}